import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import ClearSharpIcon from '@mui/icons-material/ClearSharp';
import axios from '../../API/axios';
import moment from 'moment/moment';
import { Button, DropdownItem, Modal } from 'react-bootstrap';
import NotificationsNoneSharpIcon from '@mui/icons-material/NotificationsNoneSharp';
import WorkOutlineSharpIcon from '@mui/icons-material/WorkOutlineSharp';
import ChatBubbleOutlineSharpIcon from '@mui/icons-material/ChatBubbleOutlineSharp';
import FavoriteBorderSharpIcon from '@mui/icons-material/FavoriteBorderSharp';
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";

import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import toast from 'react-hot-toast';
import { ShimmerDiv } from 'shimmer-effects-react';

// import axios from '../../API/axios';


const TopNotification = () => {
    const sessionId = localStorage.getItem("sessionId");
    const [activeTab, setActiveTab] = useState("Notifications");
    const [notifi, setNotifi] = useState([]);
    const [notifiCount, setNotifiCount] = useState();
    const [unAuthorizeError, setUnAuthorizedError] = useState("")
    const [unauthModal, setUnauthModal] = useState(false);
    const handleunauthModal = () => setUnauthModal(true);
    const handlecloseunauthModal = () => setUnauthModal(false);
    const [isLoading, setIsLoading] = useState(true);

    const NotificationList = async () => {
        setIsLoading(true);
        const data = {
            sessionId: sessionId,
        };
        try {
            const resData = await axios.post(`/Feature/GetNotifications`, data);
            console.log("resDataNew", resData.data.responseData);
            // const data= resData.data.responseData
            const reversedNotifications = (resData.data.responseData || []).reverse(); // Reversing the array
            setNotifi(reversedNotifications);
            setIsLoading(false);

        } catch (error) {
            if (error.response && error.response.status === 404) {
                console.log("data", error.response.status);
                setNotifiCount(0)
                // setUnAuthorizedError(error.response.data.message)
                // handleunauthModal()
                setIsLoading(false);

            } else {
                console.log(error);
            }
        }

    };

    const NotificationCount = async () => {
        const data = {
            sessionId: sessionId,
        };
        try {
            axios.post(`/Feature/GetNotificationsCount`, data)
                .then((resData) => {
                    console.log("countNoti", resData.data.responseData);
                    // toast.success(resData.data.message) ;   
                    setNotifiCount(resData.data.responseData);


                });
        } catch (error) {
            console.log("if error", error);
            if (error.response && error.response.status === 404) {
                // toast.error(error.response)

            } else {
                console.log("else error", error);
            }
        }
    };

    useEffect(() => {
        NotificationList();
        NotificationCount();
    }, [])




    // ............delete Notification.............

    const DeleteNotification = async (id) => {
        const data = {
            sessionId: sessionId,
            ntfctnId: id,
        };
        try {
            axios.post(`/Feature/DeleteNotification`, data)
                .then((resData) => {
                    console.log("resDataNew22", resData.data.message);
                    toast.success(resData.data.message)
                    NotificationList()
                    NotificationCount();

                });
        } catch (error) {
            if (error.response && error.response.status === 404) {
                toast.error(error.response)

            } else {
                console.log(error);
            }
        }
    };

    const ReadNotification = async (id) => {
        const responseData = {
            deviceType: "Web",
            sessionId: sessionId,
        };
        try {
            await axios
                .post(`https://preprod.welinkjobs.com/api/General/MarkNotificationAsRead?ID=${id}`, responseData)
                .then((res) => {
                    NotificationList();

                });
        } catch (e) {
            console.log(e.response);
        }
    };


    const renderNotificationItems = () => {
        return (
            <div className="notificationscroller">
                {notifi &&
                    notifi?.map((item, index) => {
                        const now = moment();
                        const itemTime = moment.utc(item?.time);
                        const duration = moment.duration(now.diff(itemTime));

                        const years = duration.years();
                        const months = duration.months();
                        const days = duration.days();
                        const hours = duration.hours();
                        const minutes = duration.minutes();

                        let result = "";

                        if (years > 0) {
                            result = `${years} year${years > 1 ? "s" : ""} ago`;
                        } else if (months > 0) {
                            result = `${months} month${months > 1 ? "s" : ""} ago`;
                        } else if (days > 0) {
                            result = `${days} day${days > 1 ? "s" : ""} ago`;
                        } else if (hours > 0) {
                            result = `${hours} hour${hours > 1 ? "s" : ""} ago`;
                        } else if (minutes > 0) {
                            result = `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
                        } else {
                            result = "just now";
                        }
                        return item?.isView === false ? (
                            <li
                                className="dropdown-menu-header"
                                key={index}
                            >
                                {
                                    <div>
                                        {/* <Link to={`/User/${item?.refLinkId}`}> */}
                                        {/* <div
                                        to={`/User/${item?.fromUserUid}`}
                                        onClick={(e) => {
                                            ReadNotification(item?.ntfctnId);
                                        }}
                                        tag={Link}
                                        className=" d-flex align-items-center"
                                    > */ /* <img
                                            src={item?.fromProfilPic}
                                            width={30}
                                            height={30}
                                            style={{ borderRadius: "50px" }}
                                            className="me-3"
                                            alt="Profile Icon"
                                        /> */}
                                        {/* <div className="d-flex"> */}

                                        <div className=" d-flex justify-content-between align-items-end">
                                            <div className="row">

                                                <h6 className="mb-0 content-text f-600">
                                                    {/* <Link to={`/job/${item?.refLinkId}`}> */}
                                                    <span>{item?.title}</span>
                                                    {/* </Link> */}
                                                </h6>
                                                <p className='mb-0 f-12'>

                                                    {moment.utc(item?.time).local().format("DD MMM YYYY")}  ( {result} )
                                                    {/* {moment.utc(item?.time).local().format("DD MMM YYYY (H:mm)")}   */}
                                                </p>
                                            </div>
                                            <div className="ms-1 d-flex align-item-center">
                                                {/* <Tooltip title="View" arrow>  */}
                                                {/* <VisibilitySharpIcon
                                                    style={{ cursor: "pointer" }}
                                                    className="joblist-eye-icon locationIcon me-2"
                                                />  */}
                                                {/* </Tooltip> */}
                                                <DeleteOutlineSharpIcon
                                                    className="material-symbols-sharp pointer delete-icon text-red  "
                                                    onClick={() => {
                                                        DeleteNotification(item.ntfctnId)
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        {/* </div> */}
                                        {item?.typeName === "JobPost" ? (
                                            <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                                                <WorkOutlineSharpIcon className="material-symbols-outlined" />
                                            </div>
                                        ) : item?.typeName === "Message" ? (
                                            <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                                                <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                                            </div>
                                        ) : item?.typeName === "Like" ? (
                                            <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                                                <FavoriteBorderSharpIcon className="material-symbols-outlined" />

                                            </div>
                                        ) : (
                                            ""
                                        )}
                                        {/* </DropdownItem> */}
                                        {/* </div> */}
                                    </div>
                                }
                            </li>
                            //     item?.type === 3 ||
                            //         item?.type === 12 ||
                            //         item?.type === 13 ||
                            //         item?.type === 14 ||
                            //         item?.type === 15 ||
                            //         item?.type === 16 ? (
                            //         <li
                            //             className="dropdown-menu-header "
                            //             key={index}
                            //         >
                            //             {
                            //                 <Link to={`/User/${item?.fromUserUid}`}>
                            //                     <DropdownItem
                            //                         to={`/User/${item?.fromUserUid}`}
                            //                         onClick={(e) => {
                            //                             ReadNotification(item?.ntfctnId);
                            //                         }}
                            //                         tag={Link}
                            //                         className="topnotification d-flex align-items-center"
                            //                     >
                            //                         {/* <img
                            //                             src={item?.fromProfilPic}
                            //                             width={30}
                            //                             height={30}
                            //                             style={{ borderRadius: "50px" }}
                            //                             className="me-3"
                            //                             alt="Profile Icon"
                            //                         /> */}
                            //                         <div className="me-3">
                            //                             {/* <h2 className="notification-message mb-0">
                            //                                 <span>{item?.fromUserFname}</span>
                            //                             </h2> */}
                            //                             <h6 className="mb-0 content-text">
                            //                                 <span>{item?.title}</span>
                            //                             </h6>
                            //                             {/* <span className="side-text ms-0">{result}</span> */}
                            //                         </div>
                            //                         {item?.typeName === "JobPost" ? (
                            //                             <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                            //                                 <WorkOutlineSharpIcon className="material-symbols-outlined" />
                            //                             </div>
                            //                         ) : item?.typeName === "Message" ? (
                            //                             <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                            //                                 <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                            //                             </div>
                            //                         ) : item?.typeName === "Like" ? (
                            //                             <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                            //                                 <FavoriteBorderSharpIcon className="material-symbols-outlined" />

                            //                             </div>
                            //                         ) : (
                            //                             ""
                            //                         )}
                            //                     </DropdownItem>
                            //                 </Link>
                            //             }
                            //         </li>
                            //     ) : item?.type === 1 ? (
                            //         <li
                            //             className="dropdown-menu-header "
                            //             key={index}
                            //         >
                            //             {
                            //                 <Link to={`/Company/${item?.fromUserUid}`}>
                            //                     <DropdownItem
                            //                         onClick={() => {
                            //                             ReadNotification(item?.ntfctnId);
                            //                         }}
                            //                         to={`/Company/${item?.fromUserUid}`}
                            //                         tag={Link}
                            //                         className="topnotification d-flex align-items-center"
                            //                     >
                            //                         <img
                            //                             src={item?.fromProfilPic}
                            //                             width={30}
                            //                             height={30}
                            //                             style={{ borderRadius: "50px" }}
                            //                             className="me-3"
                            //                             alt="Profile Icon"
                            //                         />
                            //                         <div className="me-3">
                            //                             <h2 className="notification-message mb-0">
                            //                                 <span>{item?.fromUserFname}</span>
                            //                             </h2>
                            //                             <h6 className="mb-0 content-text">
                            //                                 <span>{item?.content}</span>
                            //                             </h6>
                            //                             <span className="side-text ms-0">{result}</span>
                            //                         </div>
                            //                         {item?.typeName === "JobPost" ? (
                            //                             <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">

                            //                                 <WorkOutlineSharpIcon className="material-symbols-outlined" />
                            //                             </div>
                            //                         ) : item?.typeName === "Message" ? (
                            //                             <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                            //                                 <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                            //                             </div>
                            //                         ) : item?.typeName === "Like" ? (
                            //                             <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                            //                                 <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                            //                             </div>
                            //                         ) : (
                            //                             ""
                            //                         )}
                            //                     </DropdownItem>
                            //                 </Link>
                            //             }
                            //         </li>
                            //     ) : item?.type === 2 ? (
                            //         <li
                            //             className="dropdown-menu-header "
                            //             key={index}
                            //         >
                            //             {
                            //                 <Link to={`/Message/${item?.userId}`}>
                            //                     <DropdownItem
                            //                         onClick={(e) => {
                            //                             ReadNotification(item?.ntfctnId);
                            //                         }}
                            //                         to={`/Message/${item.userId}`}
                            //                         tag={Link}
                            //                         className="topnotification d-flex align-items-center"
                            //                     >
                            //                         <img
                            //                             src={item?.fromProfilPic}
                            //                             width={30}
                            //                             height={30}
                            //                             style={{ borderRadius: "50px" }}
                            //                             className="me-3"
                            //                             alt="Profile Icon"
                            //                         />
                            //                         <div className="me-3">
                            //                             <h2 className="notification-message mb-0">
                            //                                 <span>{item?.fromUserFname}</span>
                            //                             </h2>
                            //                             <h6 className="mb-0 content-text">
                            //                                 <span>{item?.content}</span>
                            //                             </h6>
                            //                             <span className="side-text ms-0">{result}</span>
                            //                         </div>
                            //                         {item?.typeName === "JobPost" ? (
                            //                             <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">

                            //                                 <WorkOutlineSharpIcon className="material-symbols-outlined" />
                            //                             </div>
                            //                         ) : item?.typeName === "Message" ? (
                            //                             <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                            //                                 <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                            //                             </div>
                            //                         ) : item?.typeName === "Like" ? (
                            //                             <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                            //                                 <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                            //                             </div>
                            //                         ) : (
                            //                             ""
                            //                         )}
                            //                     </DropdownItem>
                            //                 </Link>
                            //             }
                            //         </li>
                            //     ) : item?.type === 4 ||
                            //         item?.type === 5 ||
                            //         item?.type === 6 ||
                            //         item?.type === 7 ||
                            //         item?.type === 8 ||
                            //         item?.type === 9 ||
                            //         item?.type === 10 ||
                            //         item?.type === 11 ||
                            //         item?.type === 24 ||
                            //         item?.type === 18 ? (
                            //         <li
                            //             className="dropdown-menu-header "
                            //             key={index}
                            //         >
                            //             {
                            //                 <Link to={`/Post/${item?.refLinkId}`}>
                            //                     <DropdownItem
                            //                         onClick={() => {
                            //                             ReadNotification(item?.ntfctnId);
                            //                         }}
                            //                         to={`/Post/${item?.refLinkId}`}
                            //                         tag={Link}
                            //                         className="topnotification d-flex align-items-center"
                            //                     >
                            //                         <img
                            //                             src={item?.fromProfilPic}
                            //                             width={30}
                            //                             height={30}
                            //                             style={{ borderRadius: "50px" }}
                            //                             className="me-3"
                            //                             alt="Profile Icon"
                            //                         />
                            //                         <div className="me-3">
                            //                             <h2 className="notification-message mb-0">
                            //                                 <span>{item?.fromUserFname}</span>
                            //                             </h2>
                            //                             <h6 className="mb-0 content-text">
                            //                                 <span>{item?.content}</span>
                            //                             </h6>
                            //                             <span className="side-text ms-0">{result}</span>
                            //                         </div>
                            //                         {item?.typeName === "JobPost" ? (
                            //                             <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">

                            //                                 <WorkOutlineSharpIcon className="material-symbols-outlined" />
                            //                             </div>
                            //                         ) : item?.typeName === "Message" ? (
                            //                             <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                            //                                 <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                            //                             </div>
                            //                         ) : item?.typeName === "Like" ? (
                            //                             <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                            //                                 <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                            //                             </div>
                            //                         ) : (
                            //                             ""
                            //                         )}
                            //                     </DropdownItem>
                            //                 </Link>
                            //             }
                            //         </li>
                            //     ) : item?.type === 17 ||
                            //         item?.type === 19 ||
                            //         item?.type === 20 ||
                            //         item?.type === 21 ||
                            //         item?.type === 22 ||
                            //         item?.type === 23 ||
                            //         item?.type === 25 ||
                            //         item?.type === 26 ? (
                            //         <li
                            //             className="dropdown-menu-header "
                            //             key={index}
                            //         >
                            //             {
                            //                 <DropdownItem
                            //                     onClick={() => {
                            //                         ReadNotification(item?.ntfctnId);
                            //                     }}
                            //                     to={`/JobDetail/${item?.refLinkId}`}
                            //                     tag={Link}
                            //                     // to={`/Company/${item.userFrom?.bid}/${item.userFrom?.registeredByUserId}`}
                            //                     className="topnotification d-flex align-items-center"
                            //                 >
                            //                     <img
                            //                         src={item?.fromProfilPic}
                            //                         width={30}
                            //                         height={30}
                            //                         style={{ borderRadius: "50px" }}
                            //                         className="me-3"
                            //                         alt="Profile Icon"
                            //                     />
                            //                     <div className="me-3">
                            //                         <h2 className="notification-message mb-0">
                            //                             <span>{item?.fromUserFname}</span>
                            //                         </h2>
                            //                         <h6 className="mb-0 content-text">
                            //                             <span>{item?.content}</span>
                            //                         </h6>
                            //                         <span className="side-text ms-0">{result}</span>
                            //                     </div>
                            //                     {item?.typeName === "JobPost" ? (
                            //                         <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                            //                             <WorkOutlineSharpIcon className="material-symbols-outlined" />
                            //                         </div>
                            //                     ) : item?.typeName === "Message" ? (
                            //                         <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                            //                             <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                            //                         </div>
                            //                     ) : item?.typeName === "Like" ? (
                            //                         <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                            //                             <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                            //                         </div>
                            //                     ) : (
                            //                         ""
                            //                     )}
                            //                 </DropdownItem>
                            //             }
                            //         </li>
                            //     ) : (
                            //         <li
                            //             className="dropdown-menu-header "
                            //             key={index}
                            //         >
                            //             {
                            //                 <DropdownItem
                            //                     onClick={() => {
                            //                         ReadNotification(item?.ntfctnId);
                            //                     }}
                            //                     to={`/User/${item?.fromUserUid}`}
                            //                     tag={Link}
                            //                     // to={`/Company/${item.userFrom?.bid}/${item.userFrom?.registeredByUserId}`}
                            //                     className="topnotification d-flex align-items-center"
                            //                 >
                            //                     <img
                            //                         src={item?.fromProfilPic}
                            //                         width={30}
                            //                         height={30}
                            //                         style={{ borderRadius: "50px" }}
                            //                         className="me-3"
                            //                         alt="Profile Icon"
                            //                     />
                            //                     <div className="me-3">
                            //                         <h2 className="notification-message mb-0">
                            //                             <span>{item?.fromUserFname}</span>
                            //                         </h2>
                            //                         <h6 className="mb-0 content-text">
                            //                             <span>{item?.content}</span>
                            //                         </h6>
                            //                         <span className="side-text ms-0">{result}</span>
                            //                     </div>
                            //                     {item?.typeName === "JobPost" ? (
                            //                         <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                            //                             <WorkOutlineSharpIcon className="material-symbols-outlined" />
                            //                         </div>
                            //                     ) : item?.typeName === "Message" ? (
                            //                         <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                            //                             <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                            //                         </div>
                            //                     ) : item?.typeName === "Like" ? (
                            //                         <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                            //                             <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                            //                         </div>
                            //                     ) : (
                            //                         ""
                            //                     )}
                            //                 </DropdownItem>
                            //             }
                            //         </li>
                            //     )
                            // ) : item?.type === 3 ||
                            //     item?.type === 12 ||
                            //     item?.type === 13 ||
                            //     item?.type === 14 ||
                            //     item?.type === 15 ||
                            //     item?.type === 16 ? (
                            //     <li className="dropdown-menu-header " key={index}>
                            //         {
                            //             <DropdownItem
                            //                 to={`/User/${item?.fromUserUid}`}
                            //                 tag={Link}
                            //                 // to={`/Company/${item.userFrom?.bid}/${item.userFrom?.registeredByUserId}`}
                            //                 className="topnotification d-flex align-items-center"
                            //             >
                            //                 <img
                            //                     src={item?.fromProfilPic}
                            //                     width={30}
                            //                     height={30}
                            //                     style={{ borderRadius: "50px" }}
                            //                     className="me-3"
                            //                     alt="Profile Icon"
                            //                 />
                            //                 <div className="me-3">
                            //                     <h2 className="notification-message mb-0">
                            //                         <span>{item?.fromUserFname}</span>
                            //                     </h2>
                            //                     <h6 className="mb-0 content-text">
                            //                         <span>{item?.content}</span>
                            //                     </h6>
                            //                     <span className="side-text ms-0">{result}</span>
                            //                 </div>
                            //                 {item?.typeName === "JobPost" ? (
                            //                     <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                            //                         <WorkOutlineSharpIcon className="material-symbols-outlined" />
                            //                     </div>
                            //                 ) : item?.typeName === "Message" ? (
                            //                     <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                            //                         <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                            //                     </div>
                            //                 ) : item?.typeName === "Like" ? (
                            //                     <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                            //                         <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                            //                     </div>
                            //                 ) : (
                            //                     ""
                            //                 )}
                            //             </DropdownItem>
                            //         }
                            //     </li>
                            // ) : item?.type === 1 ? (
                            //     <li className="dropdown-menu-header " key={index}>
                            //         {
                            //             <DropdownItem
                            //                 to={`/Company/${item?.fromUserUid}`}
                            //                 tag={Link}
                            //                 // to={`/Company/${item.userFrom?.bid}/${item.userFrom?.registeredByUserId}`}
                            //                 className="topnotification d-flex align-items-center"
                            //             >
                            //                 <img
                            //                     src={item?.fromProfilPic}
                            //                     width={30}
                            //                     height={30}
                            //                     style={{ borderRadius: "50px" }}
                            //                     className="me-3"
                            //                     alt="Profile Icon"
                            //                 />
                            //                 <div className="me-3">
                            //                     <h2 className="notification-message mb-0">
                            //                         <span>{item?.fromUserFname}</span>
                            //                     </h2>
                            //                     <h6 className="mb-0 content-text">
                            //                         <span>{item?.content}</span>
                            //                     </h6>
                            //                     <span className="side-text ms-0">{result}</span>
                            //                 </div>
                            //                 {item?.typeName === "JobPost" ? (
                            //                     <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                            //                         <WorkOutlineSharpIcon className="material-symbols-outlined" />
                            //                     </div>
                            //                 ) : item?.typeName === "Message" ? (
                            //                     <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                            //                         <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                            //                     </div>
                            //                 ) : item?.typeName === "Like" ? (
                            //                     <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                            //                         <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                            //                     </div>
                            //                 ) : (
                            //                     ""
                            //                 )}
                            //             </DropdownItem>
                            //         }
                            //     </li>
                            // ) : item?.type === 2 ? (
                            //     <li className="dropdown-menu-header " key={index}>
                            //         {
                            //             <DropdownItem
                            //                 to={`/Message/${item?.userId}`}
                            //                 tag={Link}
                            //                 // to={`/Company/${item.userFrom?.bid}/${item.userFrom?.registeredByUserId}`}
                            //                 className="topnotification d-flex align-items-center"
                            //             >
                            //                 <img
                            //                     src={item?.fromProfilPic}
                            //                     width={30}
                            //                     height={30}
                            //                     style={{ borderRadius: "50px" }}
                            //                     className="me-3"
                            //                     alt="Profile Icon"
                            //                 />
                            //                 <div className="me-3">
                            //                     <h2 className="notification-message mb-0">
                            //                         <span>{item?.fromUserFname}</span>
                            //                     </h2>
                            //                     <h6 className="mb-0 content-text">
                            //                         <span>{item?.content}</span>
                            //                     </h6>
                            //                     <span className="side-text ms-0">{result}</span>
                            //                 </div>
                            //                 {item?.typeName === "JobPost" ? (
                            //                     <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                            //                         <WorkOutlineSharpIcon className="material-symbols-outlined" />
                            //                     </div>
                            //                 ) : item?.typeName === "Message" ? (
                            //                     <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                            //                         <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                            //                     </div>
                            //                 ) : item?.typeName === "Like" ? (
                            //                     <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                            //                         <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                            //                     </div>
                            //                 ) : (
                            //                     ""
                            //                 )}
                            //             </DropdownItem>
                            //         }
                            //     </li>
                            // ) : item?.type === 4 ||
                            //     item?.type === 5 ||
                            //     item?.type === 6 ||
                            //     item?.type === 7 ||
                            //     item?.type === 8 ||
                            //     item?.type === 9 ||
                            //     item?.type === 10 ||
                            //     item?.type === 11 ||
                            //     item?.type === 24 ||
                            //     item?.type === 18 ? (
                            //     <li className="dropdown-menu-header " key={index}>
                            //         {
                            //             <DropdownItem
                            //                 to={`/Post/${item?.refLinkId}`}
                            //                 tag={Link}
                            //                 // to={`/Company/${item.userFrom?.bid}/${item.userFrom?.registeredByUserId}`}
                            //                 className="topnotification d-flex align-items-center"
                            //             >
                            //                 <img
                            //                     src={item?.fromProfilPic}
                            //                     width={30}
                            //                     height={30}
                            //                     style={{ borderRadius: "50px" }}
                            //                     className="me-3"
                            //                     alt="Profile Icon"
                            //                 />
                            //                 <div className="me-3">
                            //                     <h2 className="notification-message mb-0">
                            //                         <span>{item?.fromUserFname}</span>
                            //                     </h2>
                            //                     <h6 className="mb-0 content-text">
                            //                         <span>{item?.content}</span>
                            //                     </h6>
                            //                     <span className="side-text ms-0">{result}</span>
                            //                 </div>
                            //                 {item?.typeName === "JobPost" ? (
                            //                     <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                            //                         <WorkOutlineSharpIcon className="material-symbols-outlined" />
                            //                     </div>
                            //                 ) : item?.typeName === "Message" ? (
                            //                     <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                            //                         <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                            //                     </div>
                            //                 ) : item?.typeName === "Like" ? (
                            //                     <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                            //                         <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                            //                     </div>
                            //                 ) : (
                            //                     ""
                            //                 )}
                            //             </DropdownItem>
                            //         }
                            //     </li>
                            // ) : item?.type === 17 ||
                            //     item?.type === 19 ||
                            //     item?.type === 20 ||
                            //     item?.type === 21 ||
                            //     item?.type === 22 ||
                            //     item?.type === 23 ||
                            //     item?.type === 25 ||
                            //     item?.type === 26 ? (
                            //     <li className="dropdown-menu-header " key={index}>
                            //         {
                            //             <DropdownItem
                            //                 to={`/JobDetail/${item?.refLinkId}`}
                            //                 tag={Link}
                            //                 // to={`/Company/${item.userFrom?.bid}/${item.userFrom?.registeredByUserId}`}
                            //                 className="topnotification d-flex align-items-center"
                            //             >
                            //                 <img
                            //                     src={item?.fromProfilPic}
                            //                     width={30}
                            //                     height={30}
                            //                     style={{ borderRadius: "50px" }}
                            //                     className="me-3"
                            //                     alt="Profile Icon"
                            //                 />
                            //                 <div className="me-3">
                            //                     <h2 className="notification-message mb-0">
                            //                         <span>{item?.fromUserFname}</span>
                            //                     </h2>
                            //                     <h6 className="mb-0 content-text">
                            //                         <span>{item?.content}</span>
                            //                     </h6>
                            //                     <span className="side-text ms-0">{result}</span>
                            //                 </div>
                            //                 {item?.typeName === "JobPost" ? (
                            //                     <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                            //                         <WorkOutlineSharpIcon className="material-symbols-outlined" />
                            //                     </div>
                            //                 ) : item?.typeName === "Message" ? (
                            //                     <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                            //                         <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                            //                     </div>
                            //                 ) : item?.typeName === "Like" ? (
                            //                     <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                            //                         <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                            //                     </div>
                            //                 ) : (
                            //                     ""
                            //                 )}
                            //             </DropdownItem>
                            //         }
                            //     </li>
                            // ) : (
                            //     <li className="dropdown-menu-header " key={index}>
                            //         {
                            //             <DropdownItem
                            //                 to={`/User/${item?.fromUserUid}`}
                            //                 tag={Link}
                            //                 // to={`/Company/${item.userFrom?.bid}/${item.userFrom?.registeredByUserId}`}
                            //                 className="topnotification d-flex align-items-center"
                            //             >
                            //                 <img
                            //                     src={item?.fromProfilPic}
                            //                     width={30}
                            //                     height={30}
                            //                     style={{ borderRadius: "50px" }}
                            //                     className="me-3"
                            //                     alt="Profile Icon"
                            //                 />
                            //                 <div className="me-3">
                            //                     <h2 className="notification-message mb-0">
                            //                         <span>{item?.fromUserFname}</span>
                            //                     </h2>
                            //                     <h6 className="mb-0 content-text">
                            //                         <span>{item?.content}</span>
                            //                     </h6>
                            //                     <span className="side-text ms-0">{result}</span>
                            //                 </div>
                            //                 {item?.typeName === "JobPost" ? (
                            //                     <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                            //                         <WorkOutlineSharpIcon className="material-symbols-outlined" />
                            //                     </div>
                            //                 ) : item?.typeName === "Message" ? (
                            //                     <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                            //                         <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                            //                     </div>
                            //                 ) : item?.typeName === "Like" ? (
                            //                     <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                            //                         <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                            //                     </div>
                            //                 ) : (
                            //                     ""
                            //                 )}
                            //             </DropdownItem>
                            //         }
                            //     </li>
                            // );
                        ) : ""

                    })}
            </div>
        );
    };
    return (
        <>
            <div className="topNotification header-customize-item bell ms-3 d-flex justify-content-center">
                <p className='notifyCount f-600'>{notifiCount}</p>
                <span className="icon-bell" onClick={() => {
                    NotificationList();
                }}></span>
                <div className="sub-notification">
                    {/* Tab Headers */}
                    <div className="tabs d-flex justify-content-center notify">
                        <div className='text-center '
                        // className={`tab ${activeTab === "Notifications" ? "active" : ""
                        //     }`}
                        // onClick={() => setActiveTab("Notifications")}
                        >
                            <h5 >Notifications </h5>
                        </div>
                    </div>

                    {/* Tab Content */}
                    <div
                        className="sub-notification-content"
                        style={{
                            height:
                                activeTab === "Notifications" && (notifi.length === 0 || notifiCount === 0)
                                    ? "50px"
                                    : "280px",
                            overflowY: "auto",
                        }}
                    >
                        {isLoading ? (
                            // Show shimmer loader
                            <div className="row mt-2">
                                {[1, 2, 3, 4].map((_, i) => (
                                    <div className="col-md-12 mb-1" key={i}>
                                        <ShimmerDiv mode="light" height={70} width={"100%"} />
                                    </div>
                                ))}
                            </div>
                        ) : notifi.length === 0 || notifiCount === 0 ? (
                            // Show empty state
                            <h6 className="text-center mt-3">You have no notifications</h6>
                        ) : (
                            // Show actual notifications
                            renderNotificationItems()
                        )}
                    </div>

                    {/* <div className="sub-notification-button">
                        <Link to={`/${activeTab}`}>Read All</Link>
                    </div> */}
                </div>
            </div>
            {/* ------------------Un Authorised Modal------------------ */}
            {unAuthorizeError ? (
                <Modal show={unauthModal} centered>
                    <Modal.Header>
                        <Modal.Title>Unauthorize session expired</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="settings">
                        <div className=" mb-3">
                            <p>{unAuthorizeError}</p>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Link
                            className="pointer"
                            to="/Login"
                            onClick={() => {
                                localStorage.removeItem("token"); // Remove authentication token
                                sessionStorage.removeItem("sessionId"); // Also clear from session storage if used
                                localStorage.removeItem("Module"); // Add this to clear stored role


                            }}
                        >
                            <button className="btn btn-danger ">Login</button>
                        </Link>
                        {/* <button onClick={handleConfirmBlock} className="btn btn-danger me-2">Login</button>  */}

                    </Modal.Footer>

                </Modal>
            ) : (
                ""
            )}

        </>
    )
}

export default TopNotification